var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuests(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.78035 0.35376C6.80789 0.35376 5.87526 0.740068 5.18763 1.4277C4.5 2.11533 4.11369 3.04797 4.11369 4.02043C4.11369 4.99289 4.5 5.92552 5.18763 6.61315C5.87526 7.30079 6.80789 7.68709 7.78035 7.68709C8.75281 7.68709 9.68545 7.30079 10.3731 6.61315C11.0607 5.92552 11.447 4.99289 11.447 4.02043C11.447 3.04797 11.0607 2.11533 10.3731 1.4277C9.68545 0.740068 8.75281 0.35376 7.78035 0.35376ZM12.3637 9.52043H3.19702C2.46768 9.52043 1.7682 9.81016 1.25248 10.3259C0.736753 10.8416 0.447021 11.5411 0.447021 12.2704C0.447021 14.3164 1.28852 15.9554 2.66902 17.0646C4.02752 18.1554 5.84985 18.6871 7.78035 18.6871C9.71085 18.6871 11.5332 18.1554 12.8917 17.0646C14.2704 15.9554 15.1137 14.3164 15.1137 12.2704C15.1137 11.5411 14.824 10.8416 14.3082 10.3259C13.7925 9.81016 13.093 9.52043 12.3637 9.52043Z",
    fill: "#FF3300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuests);
export default __webpack_public_path__ + "static/media/Guests.faccee2a89fb74bed17b0615f0c4779b.svg";
export { ForwardRef as ReactComponent };